/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Founder_Vaisakhan_RoleInputs */

const en_about_founder_vaisakhan_role = /** @type {(inputs: About_Founder_Vaisakhan_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Co-Founder & Engineering`)
};

const de_about_founder_vaisakhan_role = /** @type {(inputs: About_Founder_Vaisakhan_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mitgruender & Engineering`)
};

const fr_about_founder_vaisakhan_role = /** @type {(inputs: About_Founder_Vaisakhan_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Co-fondateur & Ingénierie`)
};

const es_about_founder_vaisakhan_role = /** @type {(inputs: About_Founder_Vaisakhan_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cofundador e ingenieria`)
};

const it_about_founder_vaisakhan_role = /** @type {(inputs: About_Founder_Vaisakhan_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cofondatore e ingegneria`)
};

const nl_about_founder_vaisakhan_role = /** @type {(inputs: About_Founder_Vaisakhan_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Medeoprichter en techniek`)
};

const pl_about_founder_vaisakhan_role = /** @type {(inputs: About_Founder_Vaisakhan_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wspolzalozyciel i inzynieria`)
};

const fi_about_founder_vaisakhan_role = /** @type {(inputs: About_Founder_Vaisakhan_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perustaja ja tekniikka`)
};

const da_about_founder_vaisakhan_role = /** @type {(inputs: About_Founder_Vaisakhan_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Medstifter og teknik`)
};

const sv_about_founder_vaisakhan_role = /** @type {(inputs: About_Founder_Vaisakhan_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Medgrundare och teknik`)
};

/**
* | output |
* | --- |
* | "Co-Founder & Engineering" |
*
* @param {About_Founder_Vaisakhan_RoleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const about_founder_vaisakhan_role = /** @type {((inputs?: About_Founder_Vaisakhan_RoleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Founder_Vaisakhan_RoleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_about_founder_vaisakhan_role(inputs)
	if (locale === "fr") return fr_about_founder_vaisakhan_role(inputs)
	if (locale === "es") return es_about_founder_vaisakhan_role(inputs)
	if (locale === "it") return it_about_founder_vaisakhan_role(inputs)
	if (locale === "nl") return nl_about_founder_vaisakhan_role(inputs)
	if (locale === "pl") return pl_about_founder_vaisakhan_role(inputs)
	if (locale === "fi") return fi_about_founder_vaisakhan_role(inputs)
	if (locale === "da") return da_about_founder_vaisakhan_role(inputs)
	if (locale === "sv") return sv_about_founder_vaisakhan_role(inputs)
	return en_about_founder_vaisakhan_role(inputs)
});